"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let TextTemplate = class TextTemplate extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    oid;
    onOid(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("oid");
    }
    objectTypes;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    formName;
    labelAlign;
    container;
    async $$load_container() {
        return {
            self: this.$fn.urlFor('create_object_by_type', { object_type: 'text-templates' }),
            object: 'list',
            data: []
        };
    }
    item;
    async $$load_item() {
        return this.oid ?
            this.$fn.fetch('get_object_by_type', { parameters: { object_type: 'text-templates', id: this.oid }, asResource: true }) :
            new this.$fn.Resource({
                name: null,
                object_type: null,
                condition: null,
                template: null,
                description: null
            });
    }
    ux;
    dataMembers = ['objectTypes', 'formId', 'formName', 'labelAlign', 'container', 'item', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                objectTypes: [{
                        value: "invoice",
                        name: this.$fn.pgettext("TextTemplate|Type", "Invoice"),
                    },
                    {
                        value: "invoice_line",
                        name: this.$fn.pgettext("TextTemplate|Type", "Invoice line"),
                    },
                ],
                formId: null,
                formName: "textTemplate",
                labelAlign: "right",
                container: null,
                item: null,
                ux: null,
            },
        };
    }
    async evh_7315092382398562_reload(event, scope) {
        return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_emit_3576_getActionArgs($event) {
        return {
            event: "saved",
            value: $event.data.response.data,
        };
    }
    async act_2248226175642056_rest_3574_getActionArgs($event) {
        return {
            method: "save",
            container: this.container,
            resource: this.item,
        };
    }
    async evh_2248226175642056_submit(event, scope) {
        return await this.actions.evh_2248226175642056_submit.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_reloadComponentData_3572 = new core_1.actions.ReloadComponentDataAction({
            events: [],
        });
        const evh_7315092382398562_reload_3571 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_reloadComponentData_3572,
            event: "reload",
            displayName: "reloadComponentData",
        });
        const evh_7315092382398562_reload = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_reload_3571],
        });
        const act_2248226175642056_emit_3576 = new core_1.actions.EmitAction({
            actionArgs: this.act_2248226175642056_emit_3576_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_saved_3575 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_emit_3576,
            event: "saved",
            displayName: "emit",
        });
        const act_2248226175642056_rest_3574 = new core_1.actions.RestAction({
            actionArgs: this.act_2248226175642056_rest_3574_getActionArgs,
            displayName: "save",
            events: [evh_2248226175642056_saved_3575],
        });
        const evh_2248226175642056_submit_3573 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_rest_3574,
            event: "submit",
            displayName: "save",
        });
        const evh_2248226175642056_submit = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_submit_3573],
        });
        return {
            act_7315092382398562_reloadComponentData_3572,
            evh_7315092382398562_reload_3571,
            evh_7315092382398562_reload,
            act_2248226175642056_emit_3576,
            evh_2248226175642056_saved_3575,
            act_2248226175642056_rest_3574,
            evh_2248226175642056_submit_3573,
            evh_2248226175642056_submit,
            save: act_2248226175642056_rest_3574,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
    }),
    __metadata("design:type", String)
], TextTemplate.prototype, "oid", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('oid'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], TextTemplate.prototype, "onOid", null);
TextTemplate = __decorate([
    (0, vue_property_decorator_1.Component)()
], TextTemplate);
exports.default = TextTemplate;
vue_property_decorator_1.Vue.component("TextTemplate", TextTemplate);
